module.exports = __webpack_public_path__ + "img/transac-right-arrow.5f696d26.svg";